import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Page, Text, View, Document } from "@react-pdf/renderer";
import { Viewer } from "../lib/PdfViewer";
import { styles } from "./styles";
import { formatDate, getDate } from "../../lib/dateHelper";
import { transformUnit } from "../lib/unitHandler";
import { useFindById, useListRecords } from "../../server/hooks/getData";

// Create Document Component
export const CalLabel = () => {
  const id = useParams().id || "";

  const { data: job, loading: jobL } = useFindById("jobs", [], id);
  const { data: initCertificate, loading: initCertL } = useListRecords("certificate", [job.id], {
    cal_number: `${job.cal_number}`,
  });
  const [width, height] = transformUnit(40, 20);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!jobL && !initCertL) {
      setLoading(false);
    }
  }, [jobL, initCertL]);

  return (
    <>
      {!loading && (
        <Viewer>
          {job.id ? (
            <Document>
              <Page size={[width, height]} style={[styles.page, { fontSize: 9, padding: 3 }]}>
                <View style={[styles.row, { borderBottom: 0.5 }]}>
                  <View style={styles.col}>
                    <Text style={{ fontWeight: 700 }}>COMMED KFT</Text>
                  </View>
                </View>
                <View style={[styles.row]}>
                  <View style={styles.col}>
                    <Text style={{ fontStyle: "italic", fontSize: 7 }}>Kalibráló laboratórium</Text>
                    <Text style={{ fontSize: 6 }}>www.muszeroazis.hu | +36 20 222 2626</Text>
                  </View>
                </View>
                <View style={[styles.row]}>
                  <View style={styles.col}>
                    <Text style={{ fontWeight: 700, fontSize: 8 }}>Kal. dátum:</Text>
                  </View>
                  <View style={styles.col}>
                    <Text style={{ fontWeight: 700, fontSize: 8, textAlign: "right" }}>
                      {`${formatDate(initCertificate.data[0]?.cal_date)}`}
                    </Text>
                  </View>
                </View>
                <View style={[styles.row]}>
                  <View style={[styles.col, { verticalAlign: "sub" }]}>
                    <Text
                      style={{
                        fontWeight: 700,
                        fontSize: 8,
                        verticalAlign: "sub",
                      }}>
                      Kal. szám:
                    </Text>
                  </View>
                  <View style={styles.col}>
                    <Text
                      style={{
                        fontWeight: 700,
                        fontSize: 12,
                        textAlign: "right",
                        verticalAlign: "sub",
                      }}>
                      {`${job.cal_number_prefix ?? ""}${job.cal_number ?? "---"}`}
                    </Text>
                  </View>
                </View>
              </Page>
            </Document>
          ) : (
            ""
          )}
        </Viewer>
      )}
    </>
  );
};
